<template>
    <div class="link-list-info">
        <!-- submission page -->
        <div v-if="full">
            <div class="info">

                <router-link
                        class="post_info"
                        v-text="submission.channel_title"
                        :to="channelUrl(submission.channel_name)"
                ></router-link>


                <router-link :to="/l/+submission.location.slug">({{submission.location.name}})</router-link>
                <!--<span class="set_background_color">Law</span>-->
                <!--<router-link class="post_info" v-text="list.channel_name"-->
                <!--:to="channelUrl(list.channel_name)"></router-link>-->


                <router-link
                        v-if="!submission.deleted_by"
                        class="post_info"
                        v-text="'posted by ' + submission.author.username"
                        :to="userUrl(submission.author.username)"
                ></router-link>
                <span v-else class="post_info" v-text="'[deleted]'"></span>

                <span>
				<router-link class="date time_ago"
                             v-text="date"
                             :to="url_2"></router-link>
				</span>

            </div>


            <h1 class="submission-title">
                {{ submission.title }}

                <el-tag size="mini" type="danger" class="margin-left-half" v-if="submission.nsfw">NSFW</el-tag>
            </h1>

            <div style="margin: 0px; max-width: 700px;" v-html="submission.content.description">
            </div>
            <!--<markdown :text="body" v-if="body && !editing"></markdown>-->

            <el-input
                    v-show="editing"
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 25 }"
                    id="text"
                    placeholder="Text(optional)..."
                    v-model="editedBody"
                    :maxlength="15000"
            ></el-input>

            <div class="flex-space margin-top-1" v-show="editing">
                <div>
                    <el-button round type="success" @click="patch" :loading="loading" size=mini>
                        Save
                    </el-button>
                    <el-button type="text" @click="cancelEditing" size="mini">
                        Cancel
                    </el-button>
                </div>

                <div>
                    <el-button type="text" @click="$eventHub.$emit('markdown-guide')" size="mini">
                        Formatting Guide
                    </el-button>

                    <el-button @click="preview = !preview" type="text" size="mini"
                               :icon="preview ? 'el-icon-close' : 'el-icon-view'"
                    >
                        Preview
                    </el-button>
                </div>
            </div>

            <div v-if="editing && preview" class="form-wrapper margin-bottom-1 margin-top-1 preview">
                <markdown v-if="editedBody" :text="editedBody.trim()"></markdown>
            </div>
        </div>

        <!-- submission indexing pages -->
        <div v-else>
            <h3 class="title">
                <router-link :to="'/p/' + submission.slug"
                             class="flex-space v-ultra-bold"
                >
                    {{ submission.title }}

                    <el-tag size="mini" type="danger" class="margin-left-half" v-if="submission.nsfw">NSFW</el-tag>
                </router-link>
            </h3>

            <submission-footer :url="url" :comments="comments" :bookmarked="bookmarked" :submission="submission"
                               @bookmark="$emit('bookmark')" @report="$emit('report')" @hide="$emit('hide')"
                               @nsfw="$emit('nsfw')" @sfw="$emit('sfw')" @destroy="$emit('destroy')"
                               @approve="$emit('approve')" @disapprove="$emit('disapprove')"
                               @removethumbnail="$emit('removethumbnail')" :liked="liked" :points="points"
                               @like="$emit('like')"
            ></submission-footer>
        </div>
    </div>
</template>

<script>
    import Markdown from '../../components/Markdown.vue';
    import SubmissionFooter from '../../components/SubmissionFooter.vue';
    import Helpers from '../../mixins/Helpers';
    //import Submission from '../../mixins/Submission';

    export default {
        mixins: [Helpers],
        data() {
            return {
                editing: false,
                body: this.submission.content.description,
                editedBody: this.submission.content.description,
                preview: false,
                loading: false
            };
        },

        props: {
            nsfw: {},
            submission: {},
            url: {},
            comments: {},
            bookmarked: {},
            liked: {},
            points: {},
            full: {
                type: Boolean,
                default: false
            }
        },

        components: {
            Markdown,
            SubmissionFooter
        },

        watch: {
            submission() {
                this.body = this.submission.content.description;
                this.editedBody = this.submission.content.description;
            }
        },

        created() {
            this.$eventHub.$on('edit-submission', this.editSubmission);
        },

        beforeDestroy() {
            this.$eventHub.$off('edit-submission', this.editSubmission);
        },
        computed: {
            url_2() {
                return this.submissionUrl(this.submission);
            },
            date() {
                return this.parsDiffForHumans(this.submission.created_at);
            }
        },
        methods: {
            /**
             * opens the edit form
             *
             * @return void
             */
            editSubmission() {
                this.editing = !this.editing;
            },

            /**
             * patches the TextSubmission
             *
             * @return void
             */
            patch() {
                this.loading = true;

                axios
                    .patch(`/submissions/${this.submission.id}`, {
                        description: this.editedBody
                    })
                    .then(() => {
                        this.body = this.editedBody;
                        this.editing = false;
                        this.loading = false;
                    })
                    .catch(() => {
                        this.editing = true;
                        this.loading = false;
                    });
            },

            /**
             * cancels editing the TextSubmission
             *
             * @return void
             */
            cancelEditing() {
                this.editedBody = this.body;
                this.editing = false;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/submission/TextSubmission.vue